// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_uzG","cls2":"SimplePaperPodcast-cls2_Xq_ SimplePaperPodcast-cls1_uzG"};